/*
 * @Author: Claude
 * @Date: 2025-12-31
 * @Description: 统一上传配置
 */

import { UploadConfig } from './types';

/**
 * 默认上传场景类型（对应后端 dirSceneType）
 */
export const DEFAULT_DIR_SCENE_TYPE = 20;

/**
 * 默认上传配置
 * 所有上传类型（图片、视频、音频）使用相同的配置
 */
export const defaultConfig: UploadConfig = {
  dirSceneType: DEFAULT_DIR_SCENE_TYPE,
};

// 向后兼容导出
/** @deprecated 使用 defaultConfig 替代 */
export const imageConfig = defaultConfig;
/** @deprecated 使用 defaultConfig 替代 */
export const videoConfig = defaultConfig;
/** @deprecated 使用 defaultConfig 替代 */
export const audioConfig = defaultConfig;
/** @deprecated 使用 defaultConfig 替代 */
export const commonConfig = defaultConfig;

// 向后兼容常量导出
/** @deprecated 使用 DEFAULT_DIR_SCENE_TYPE 替代 */
export const IMAGE_DIR_SCENE_TYPE = DEFAULT_DIR_SCENE_TYPE;
/** @deprecated 使用 DEFAULT_DIR_SCENE_TYPE 替代 */
export const VIDEO_DIR_SCENE_TYPE = DEFAULT_DIR_SCENE_TYPE;
/** @deprecated 使用 DEFAULT_DIR_SCENE_TYPE 替代 */
export const AUDIO_DIR_SCENE_TYPE = DEFAULT_DIR_SCENE_TYPE;
/** @deprecated 使用 DEFAULT_DIR_SCENE_TYPE 替代 */
export const COMMON_DIR_SCENE_TYPE = DEFAULT_DIR_SCENE_TYPE;
